import React from 'react';
import styles from './Map.module.css';

import marker from '../../../images/Map/Marker.png';

const Map = () => {
    return (
        <div id='section3' className={styles.container}>
            <h1 className={styles.header}>Доставка</h1>

            <div className={styles.column}>
                <h2 className={styles.column_h2}>
                    <span style={{ color: 'red' }}>
                        Безкоштовна доставка
                    </span>{' '}
                    при оренді{' '}
                    <span style={{ borderBottom: '3px solid red' }}>
                        від 7 днів
                    </span>{' '}
                    будь-якого комплекту!
                </h2>

                

                <h2 className={styles.column_h2} style={{ textAlign: 'left' }}>
                    <img className={styles.marker} src={marker} alt="Marker" /><span className={styles.span_inline}>Самовивіз безкоштовно</span>
                </h2>

                <p>
                    Ви можете самостійно приїхати до магазину для отримання, повернення чи заміни консолі.
                </p>

                <p className={styles.p2}>
                    Ми працюємо щодня з 12:00 до 18:00.
                </p>
            </div>
        </div>
    );
};

export default Map;